"use client";

import * as React from "react";
import { Award, Clock, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseRomeroWeldingInc() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: Award,
    title: "High-quality workmanship"
  }, {
    icon: Clock,
    title: "Timely service delivery"
  }, {
    icon: Users,
    title: "Personalized customer attention"
  }];
  return <section className="relative bg-dark-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <h2 className="mb-12 text-center font-display text-3xl font-bold text-white md:text-4xl">
          Why Choose Romero Welding Inc.?
        </h2>

        <div className="grid gap-8 md:grid-cols-3">
          <div ref={card1Ref} data-index={0} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${card1Visible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`}>
            <Card className="group h-full border border-border/20 bg-surface/10 backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong">
              <CardContent className="flex flex-col items-center gap-4 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
                  <Award className="h-8 w-8 text-primary" />
                </div>
                <p className="font-sans text-lg font-medium text-white/90">
                  {benefits[0].title}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={card2Ref} data-index={1} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${card2Visible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`} style={{
          transitionDelay: "100ms"
        }}>
            <Card className="group h-full border border-border/20 bg-surface/10 backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong">
              <CardContent className="flex flex-col items-center gap-4 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
                  <Clock className="h-8 w-8 text-primary" />
                </div>
                <p className="font-sans text-lg font-medium text-white/90">
                  {benefits[1].title}
                </p>
              </CardContent>
            </Card>
          </div>

          <div ref={card3Ref} data-index={2} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${card3Visible ? "translate-x-0 opacity-100" : "-translate-x-8 opacity-0"}`} style={{
          transitionDelay: "200ms"
        }}>
            <Card className="group h-full border border-border/20 bg-surface/10 backdrop-blur-sm transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-strong">
              <CardContent className="flex flex-col items-center gap-4 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
                  <Users className="h-8 w-8 text-primary" />
                </div>
                <p className="font-sans text-lg font-medium text-white/90">
                  {benefits[2].title}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}